import {useLocation} from 'hooks'
import qs from 'qs'

export default function useSearch(key, def) {
  const {search} = useLocation()
  return qs.parse(search, {ignoreQueryPrefix: true})[key] || def
}

